/* eslint-disable no-use-before-define */
import React from 'react'
import { publish, } from '../twd/twd'


export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError:false }
    }
    static getDerivedStateFromError(error) {
        return {hasError:true}
    }
    componentDidCatch(error) {
        console.log('ERROR', error)
    }
    render() {
        if (this.state.hasError) {
            // eslint-disable-next-line
            this.state.hasError = false

            setTimeout(() => publish('error-boundary'))
            return null
        }
        return this.props.children
    }
}



// WEBPACK FOOTER //
// ./src/orders/error-boundary.js